define.alias("ember-cli-string-helpers/helpers/dasherize", "preview-grid/helpers/dasherize");